import {
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import { useMemo, useState } from "react";

import { MUTATIONS } from "../../../../graphql";
import { AppVersion, AppVersionPlatform } from "../../../../graphql/models";
import { useSnackbarMutation } from "../../../../hooks";
import { ConfirmButtonWithDialog } from "../../../components";
import AppPlatformPicker from "../components/app-platform-picker";

import useAppVersionFormStyles from "./app-versions-form.style";

export interface AppVersionEditFormProps {
  value: AppVersion | undefined;
  onValueDeleted: () => void;
  onValueUpdatedSuccessfully: (v: AppVersion) => void;
}

export function AppVersionEditForm(props: AppVersionEditFormProps) {
  const { value, onValueDeleted, onValueUpdatedSuccessfully } = props;
  const classes = useAppVersionFormStyles();

  let mutation = MUTATIONS.CREATE_APP_VERSION;
  if (value && value?.id) {
    mutation = MUTATIONS.UPDATE_APP_VERSION;
  }

  const [invokeCreateOrUpdate, { loading }] = useSnackbarMutation(mutation, {
    onCompleted: (_) => {
      // Todo: this is slightly bad.
      onValueUpdatedSuccessfully(value as AppVersion);
    },
  });

  const [invokeDeleteAppVersion, { loading: deletingAppVersion }] =
    useSnackbarMutation(MUTATIONS.DELETE_APP_VERSION, {
      onCompleted: onValueDeleted,
    });

  const isLoading = useMemo(
    () => loading || deletingAppVersion,
    [deletingAppVersion, loading]
  );

  // const [label, setLabel] = useState<string | undefined>(value?.label);
  // const [description, setDescription] = useState<string | undefined>(
  //   value?.description
  // );
  const [platform, setPlatform] = useState<AppVersionPlatform>(
    value?.platform ?? AppVersionPlatform.ANDROID
  );
  const [version, setVersion] = useState<string | undefined>(value?.version);
  const [buildNumber, setBuildNumber] = useState<string | undefined>(
    value?.buildNumber
  );
  const [mustUpdate, setMustUpdate] = useState<boolean>(
    value?.mustUpdate ?? false
  );
  const [deprecated, setDeprecated] = useState<boolean>(
    value?.deprecated ?? false
  );

  const onFormSubmit = (evt) => {
    evt.preventDefault();
    invokeCreateOrUpdate({
      variables: {
        id: (value as AppVersion)?.id,
        appVersionData: {
          platform,
          version,
          buildNumber,
          mustUpdate,
          deprecated,
          rawVersion: [version, buildNumber].join("+"),
        },
      },
    });
  };

  const triggerInvokeDeleteAppVersion = () => {
    invokeDeleteAppVersion({
      variables: {
        id: value?.id,
      },
    });
  };

  return (
    <form
      className={classes.root}
      onSubmit={onFormSubmit}
      noValidate
      autoComplete="off"
    >
      <Paper style={{ width: "100%" }}>
        <Grid container spacing={3}>
          <Grid item sm={3} xs={12}>
            <Typography variant="caption">Piattaforma</Typography>
            <AppPlatformPicker
              style={{ width: "100%" }}
              value={platform}
              onChange={(evt) =>
                setPlatform(evt.target.value as AppVersionPlatform)
              }
            />
          </Grid>
          <Grid item sm={3} xs={12}>
            <Typography variant="caption">Versione</Typography>
            <TextField
              className={classes.textField}
              placeholder="Codice versione (es. 1.2.3)"
              value={version}
              onChange={(evt) => setVersion(evt.target.value)}
            />
          </Grid>
          <Grid item sm={3} xs={12}>
            <Typography variant="caption">Build number</Typography>
            <TextField
              className={classes.textField}
              placeholder="Build number (es. 96)"
              value={buildNumber}
              onChange={(evt) => setBuildNumber(evt.target.value)}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item sm={2} xs={2}>
            Release Obbligatoria?
            <Checkbox
              checked={mustUpdate}
              onChange={(_evt, checked) => setMustUpdate(checked)}
            />
          </Grid>
          <Grid item sm={2} xs={2}>
            Release obsoleta?
            <Checkbox
              checked={deprecated}
              onChange={(_evt, checked) => setDeprecated(checked)}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Button
              className={classes.textField}
              type="submit"
              variant="contained"
              color="primary"
            >
              {!isLoading ? "Salva" : <CircularProgress />}
            </Button>
          </Grid>
          {value?.id && (
            <Grid item sm={12} xs={12}>
              <ConfirmButtonWithDialog
                className={classes.textField}
                type="button"
                variant="contained"
                color="secondary"
                dialogProps={{
                  fullScreen: false,
                  title: "Conferma eliminazione",
                }}
                dialogContent={
                  "Confermi di voler eliminare definitivamente questo elemento? l'operazione è irreversibile."
                }
                onConfirm={() => triggerInvokeDeleteAppVersion()}
                onUndo={() => void 0}
              >
                {!isLoading ? "Elimina" : <CircularProgress />}
              </ConfirmButtonWithDialog>
            </Grid>
          )}
        </Grid>
      </Paper>
    </form>
  );
}
